import { View } from '@fairygodboss/ui';
import React from 'react';

import { UseModalState } from '../../../context/ModalContext';
import { EmitMetric } from '../../../utils/Analytics/VisibilityPixel/VisibilityPixel';
import useUser from '../../../utils/useUser';

export const AuthWrapper = ({
    children,
    redirectUrl,
    loginTrigger,
    customMetric,
    customStyle,
}) => {
    const { user } = useUser();
    const {
        setModalOpen,
        setAuth0,
        setLoginRedirectPath,
        setModal,
        setIsPayWall,
        setRegWall,
        setLayoutType,
        setLeadInLogin,
        setLeadInPopup,
        setLoginMetrics,
    } = UseModalState();
    return (
        <View
            as="span"
            style={customStyle}
            onClick={() => {
                if (!user.isLoggedIn) {
                    setModalOpen(true);
                    setModal('signin');
                    setLoginRedirectPath(redirectUrl);
                    setAuth0(loginTrigger);
                    setIsPayWall(false);
                    setRegWall(false);
                    setLayoutType(String('create'));
                    setLeadInLogin(null);
                    setLeadInPopup(null);
                    setLoginMetrics(customMetric);
                    if (loginTrigger) {
                        EmitMetric({
                            misc_event_type: loginTrigger,
                            misc_event_count: 1,
                        });
                    }
                }
            }}
        >
            {children}
        </View>
    );
};
